import styled from "styled-components";

export const RememberSection = styled.div`
  display: flex;
  position: relative;
  /* right: 9px; */
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  .container {
    margin: 0;
  }
  label {
    color: #000;
    padding-left: 10px;
    padding-top: 0;
    font-size: 14px;
  }
  .container {
    margin-bottom: 0;
  }
  > div:nth-child(2) {
    color: #2b3ed4;
    font-size: 14px;
    letter-spacing: 0.23px;
  }
  a {
    letter-spacing: 0px;
    color: #6f7172;
  }
  .checkBox {
    margin-right: 6px;
  }
  .forgotPassword {
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
    text-decoration: underline;
    margin-bottom: 0;
    font-weight: normal;
    color: #68a107;
  }
  .checkMark {
    top: -2px t;
  }
`;

export const Heading = styled.div`
  font-family: "latobold";
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 40px;
`;

export const SubHeading = styled.div`
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 20px;
`;
